import { createSelector } from '@reduxjs/toolkit'
import { path, prop } from 'lodash/fp'

import {
  AUTH_REDUCER_NAME,
  USER_REDUCER_NAME,
  PASS_INIT_RESET_REDUCER_NAME,
} from './consts'

import { makeFetchSelectors } from 'app/redux-fetch/selectors'

export const passInitResetSelectors = makeFetchSelectors(
  AUTH_REDUCER_NAME,
  PASS_INIT_RESET_REDUCER_NAME
)

const selectUserState = path([AUTH_REDUCER_NAME, USER_REDUCER_NAME])

export const hasUserStateLoadedSelector = createSelector(
  selectUserState,
  prop('hasLoaded')
)

export const isAuthenticatedSelector = createSelector(
  selectUserState,
  ({ user, hasLoaded }) => hasLoaded && !!user
)

export const currentUserSelector = createSelector(selectUserState, prop('user'))
